import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import React from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { useLanguageQuery } from '../../../../../graphql/query/language/useLanguageQuery';
import useLanguage from '../../../_hook/useLanguage';

interface IProps {
  type: 'richtext' | 'textarea' | 'input';
  onChange: (la: string) => void;
  language: string;
  variant?: 'standard' | 'outlined' | 'filled';
}

const useStyles = makeStyles<Theme, IProps>((theme) => ({
  selectLanguage: {
    borderRadius: ({ type }) => (type === 'textarea' ? 0 : 'initial'),
    backgroundColor: ({ type }) => {
      if (type === 'textarea') {
        if (theme.palette.mode === 'light') {
          return '#f3f3f3';
        }
        return 'inherit';
      }
      return 'initial';
    },
  },
}));

export default function InputTranslationLanguageSelect(props: IProps) {
  const { type, language, onChange, variant } = props;
  const { getText } = useLanguage();
  const classes = useStyles(props);
  const { data } = useLanguageQuery(
    `
      _id
      code
      name {
        text
        la
      }
  `,
    {
      variables: {
        filter: {
          status: true,
        },
        sort: {
          code: 1,
        },
      },
    }
  );
  const languages = data && data.languages ? data.languages.items : [];
  return (
    <Select
      value={language}
      fullWidth={type !== 'input'}
      variant={variant}
      className={classes.selectLanguage}
      onChange={(event) => onChange(event.target.value as string)}
    >
      {languages.map((tempLanguage) => (
        <MenuItem key={tempLanguage._id} value={tempLanguage.code}>
          {getText(tempLanguage.name)}
        </MenuItem>
      ))}
    </Select>
  );
}
